import { supabase } from './supabase';
import { storageObjectPath } from './storageObjectPath';

export async function resolvePrivatePhoto(value: string): Promise<string> {
  for (const bucket of ['maintenance-photos', 'profile-pictures']) {
    const base = supabase.storage.from(bucket).getPublicUrl('').data.publicUrl;
    try {
      const path = storageObjectPath(value, bucket, base);
      const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 300);
      if (error || !data?.signedUrl) throw new Error('Photo unavailable');
      return data.signedUrl;
    } catch (error) {
      // Only try the other bucket for a URL from a different bucket. Never fall back to public access.
      if (value.includes(`/object/public/${bucket}/`) || value.includes(`/object/authenticated/${bucket}/`) || value.includes(`/object/sign/${bucket}/`)) throw error;
    }
  }
  throw new Error('Unsupported photo location');
}
